import { render, staticRenderFns } from "./CartDropdown.vue?vue&type=template&id=b8bc46dc"
import script from "./CartDropdown.vue?vue&type=script&lang=js"
export * from "./CartDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports